const ChevronIcon = ({ className, direction = 'down', isSelected = false }) => {
  const fillColor = isSelected ? 'var(--forbrand-primary)' : 'var(--forbrand-secondary)'
  const rotation = direction === 'up' ? 'rotate-180' : ''

  return (
    <div className={`${className} flex  w-[16px] h-[16px] ${rotation}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default ChevronIcon
